import React from "react";

const Logo = ({ className = "h-14" }) => {
  return (
    <img
      src="/onevo-logo.png"
      alt="ONEVO Premium Training Studio"
      className={`${className} w-auto object-contain select-none`}
      draggable="false"
    />
  );
};

export default Logo;
